import appConfig from '../bootstrap/app_config';
export var BFF_RANDOM_NUMBER_API_PATH = appConfig.SERVER_URL + "/v1/teams";
export var BFF_BOOTSTRAP_DATA_API_PATH = appConfig.SERVER_URL + "/v1/bootstrap_data";
export var BFF_PORTAL_DATA_API_PATH = appConfig.SERVER_URL + "/v1/portal_data";
export var BFF_MEMBERS_API_PATH = appConfig.SERVER_URL + "/v1/members";
export var BFF_JOIN_TEAM_ACCOUNTS_API_PATH = appConfig.SERVER_URL + "/v1/join";
export var BFF_ADD_MEMBERS_API_PATH = appConfig.SERVER_URL + "/v1/add_members";
export var BFF_ADD_GROUP_MEMBERS_API_PATH = appConfig.SERVER_URL + "/v1/add_group_members";
export var BFF_REMOVE_MEMBER_API_PATH = appConfig.SERVER_URL + "/v1/remove_member";
export var BFF_TEAM_ACCOUNT_BUDGETS_API_PATH = appConfig.SERVER_URL + "/v1/team_account_budgets";
export var BFF_ADD_TEAM_ACCOUNT_BUDGET_API_PATH = appConfig.SERVER_URL + "/v1/add_team_account_budget";
export var BFF_UPDATE_TEAM_ACCOUNT_BUDGET_API_PATH = appConfig.SERVER_URL + "/v1/update_team_account_budget";
export var BFF_DELETE_BUDGET_API_PATH = appConfig.SERVER_URL + "/v1/delete_budget";
export var BFF_TEAM_ACCOUNT_BUDGET_CONFIGURATION_OPTIONS_API_PATH = appConfig.SERVER_URL + "/v1/budget_configuration_options";
export var BFF_DOWNLOAD_ORDER_HISTORY_API_PATH = appConfig.SERVER_URL + "/v1/order_history";
export var BFF_ADD_TEAM_ACCOUNT_GROUP_API_PATH = appConfig.SERVER_URL + "/v1/add_team_account_group";
export var BFF_EDIT_TEAM_ACCOUNT_GROUP_API_PATH = appConfig.SERVER_URL + "/v1/update_team_account_group";
export var BFF_GET_TEAM_ACCOUNT_GROUPS_API_PATH = appConfig.SERVER_URL + "/v1/team_account_groups";
export var BFF_DELETE_TEAM_ACCOUNT_GROUP_API_PATH = appConfig.SERVER_URL + "/v1/delete_team_account_group";
export var BFF_GET_TEAM_ACCOUNT_GROUP_MEMBERS_API_PATH = appConfig.SERVER_URL + "/v1/team_account_group_members";
export var BFF_REMOVE_TEAM_ACCOUNT_GROUP_MEMBERS_API_PATH = appConfig.SERVER_URL + "/v1/remove_group_members";
export var BFF_REMOVE_ADMIN_ROLE_API_PATH = appConfig.SERVER_URL + "/v1/remove_admin_role";
export var BFF_ADD_ADMIN_ROLE_API_PATH = appConfig.SERVER_URL + "/v1/add_admin_role";
export var DEFAULT_PAGE_SIZE = 10;
export var DEFAULT_GROUP_MEMBERS_PAGE_SIZE = 10;
export var PORTAL_ROUTE_PREFIX = '/teams';
var PRODUCTION_BASE_URL = 'https://www.doordash.com';
var EXTERNAL_PATHS = {
    BENEFITS_PAGE: '/benefits',
};
export var EXTERNAL_ROUTES = {
    BENEFITS_PAGE: "" + PRODUCTION_BASE_URL + EXTERNAL_PATHS.BENEFITS_PAGE,
};
// Strings we get back from API
export var ACTIVE_MEMBER_STATUS_STRING = 'ACTIVE';
export var PENDING_MEMBER_STATUS_STRING = 'PENDING';
// Will use i18n for these when we set it up
export var ACTIVE_MEMBER_STATUS_TEXT = 'Active';
export var PENDING_MEMBER_STATUS_TEXT = 'Pending';
// Identity service related values
// production env
export var IDENTITY_SERVICE_WEB_BFF_CLIENT_ID = '1666519390426295040';
export var IDENTITY_SERVICE_BASE_URL = 'https://identity.doordash.com';
export var IDENTITY_SERVICE_DEFAULT_REDIRECT_BASE_URL = 'https://www.doordash.com';
export var IDENTITY_SERVICE_POST_LOGIN_PATH = '/post-login';
export var IDENTITY_SERVICE_POST_LOGOUT_PATH = '/post-logout';
// Identity Service auth url
export var IDENTITY_SERVICE_AUTH_URL = IDENTITY_SERVICE_BASE_URL + "/auth";
export var IDENTITY_SERVICE_SIGNUP_URL = IDENTITY_SERVICE_BASE_URL + "/auth/user/signup";
export var IMAGE_BASE_URL = 'https://img.cdn4dd.com';
// Error messages
export var ERROR_MESSAGE_NOT_LOGGED_IN = 'Not logged in.';
export var ERROR_MESSAGE_TEAM_NOT_FOUND = 'Team not found.';
// Treat this as an entry point of the app
// for admin going here will redirect the admin to the /admins route
// for non admin going here will redirect the them to the app-consumer benefits page
export var HOME_PAGE_PATH = PORTAL_ROUTE_PREFIX + "/home";
// Key codes
export var KEY_CODES = {
    ESCAPE: 27,
    ENTER: 13,
};
export var HELP_URL = 'https://help.doordash.com/work/s';
export var CONTACT_SUPPORT_URL = HELP_URL + "/work-support?language=en_US";
export var CONTACT_SALES_URL = function (teamAccountId) {
    return "mailto:work-expansion@doordash.com?subject=DDFW%20Upgrade%20Request%20-%20Account%20ID%20" + teamAccountId;
};
export var TERMS_OF_SERVICE_URL = HELP_URL + "/terms-and-conditions-us?language=en_US";
export var DDFW_GIFT_CARD_URL = 'https://doordashwork.launchgiftcards.com/';
